import { useEffect, useRef, useState } from "react";

import { cn } from "utils";

import defaultLogo from "images/squirrel.gif";

export const DivLoader = ({
  loading,
  children,
  logo,
  message = "Loading",
  shouldFadeOut,
}) => {
  const [showLoader, setShowLoader] = useState(loading);
  const [fadeOut, setFadeOut] = useState(false);

  const timeoutRef = useRef(null);

  useEffect(() => {
    if (loading) {
      clearTimeout(timeoutRef.current);
      setShowLoader(loading);
      shouldFadeOut && setFadeOut(false);
      return;
    }

    if (!loading && showLoader) {
      setFadeOut(true);
      timeoutRef.current = setTimeout(
        () => {
          setShowLoader(false);
          setFadeOut(false);
        },
        shouldFadeOut ? 700 : 0
      );
    }

    return () => clearTimeout(timeoutRef.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, showLoader]);

  return (
    <div className="relative">
      {showLoader && (
        <>
          <div
            className={cn(
              "absolute inset-0 bg-white/90 z-20 pointer-events-auto transition transform translate-y-0 !ease-in",
              {
                "!translate-y-full": fadeOut,
                "duration-700": shouldFadeOut,
              }
            )}
          >
            <div className="sticky top-1/2 h-0 overflow-visible z-30 flex items-center justify-center pointer-events-none px-4">
              <div className="mt-14 transform -translate-y-1/2">
                <div className="flex justify-center">
                  <div className="w-20 h-20 p-1">
                    <img
                      src={logo || defaultLogo}
                      alt="loading"
                      aria-hidden="true"
                      className="w-full h-full"
                    />
                  </div>
                </div>

                <p className="mt-4 font-bold text-2xl text-center max-w-lg">
                  {message}
                  <span className="ml-1 inline-block w-5 after:animate-dots" />
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      <div className={loading ? "pointer-events-none" : ""}>{children}</div>
    </div>
  );
};

export default DivLoader;
